import { render, staticRenderFns } from "./PointDrawer.vue?vue&type=template&id=47d68f74&scoped=true"
import script from "./PointDrawer.vue?vue&type=script&lang=js"
export * from "./PointDrawer.vue?vue&type=script&lang=js"
import style0 from "./PointDrawer.vue?vue&type=style&index=0&id=47d68f74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d68f74",
  null
  
)

export default component.exports